export default __webpack_public_path__ + "642fa7bb9d5e7c302632e955a2262c6e.png";